import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Globals } from '../globals';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';
import { ApiService } from '../services/api/api.service';
const validateEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers:[ApiService],
})

export class LoginComponent implements OnInit {
  public type = "password";
  fm: FormGroup;
  constructor(public api: ApiService , vcr: ViewContainerRef, public toastr: ToastsManager, public fb: FormBuilder, public router: Router, public globals: Globals) {
    this.toastr.setRootViewContainerRef(vcr);
    let item = this.globals.USERS.get();
    this.fm = this.fb.group({
      email: [item.email ? item.email : '', [Validators.required, Validators.pattern(validateEmail)]],
      password: [item.password ? item.password : '', [Validators.required]]
    });
    
  }
  ngOnInit() {


  }
  onSubmit() {
    let data: any = this.fm.value;
    
    
    this.api.admiLogin(data).subscribe(res => {
      let type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
      this.toastr[type](res['message'], type);
      
      
      if (res['status'] == 1) {
        this.globals.USERS.set(Object.assign(res['data'],data));
        setTimeout(() => {
          this.router.navigate(['/admin/dashboard']);
        }, 2000);
      }
    });

  }

}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/login/login.component.ts